jQuery('document').ready(function(){

    
    if (window.location.href.indexOf("beer-archive") > -1) {
        $('.available_block').hide();
    }

    isItemsInCartMatchLocation();

    var zipCodes = [10001,10010,10016,10017,10018,10019,10020,10021,10022,10023,10024,10025,10026,10028,10029,10036,10065,10075,10128,10069,10162,10171,10107,10154,10002,10003,10004,10005,10006,10007,10009,10011,10012,10013,10014,10038,10048,10280,10282,11206,11213,11221,11233,11237,11216,11225,11101,11102,11104,11106,11109,11377,11378,11103,11105,10044,11507,11701,11702,11703,11510,11704,11709,11001,11002,11710,11714,11514,11516,11726,11729,11554,11518,11596,11003,11010,11520,11530,11531,11599,11542,11547,11023,11026,11021,11022,11549,11550,11551,11557,11801,11802,11735,11795,11753,11853,11024,11020,11570,11756,11757,11560,11563,11565,11030,11758,11762,11775,11566,11765,11501,11590,11040,11572,11545,11568,11051,11053,11571,11575,11576,11548,11577,11050,11579,11783,11773,11553,11580,11581,11582,11793,11552,11598,11798,11004,11005,11354,11355,11356,11357,11358,11359,11360,11361,11362,11363,11364,11365,11366,11367,11411,11412,11413,11422,11423,11426,11427,11428,11429,11432,11433,11434,11435,11436,11368,11379,11374,11375,11415,11418,11421,11731,11768,11747,11804,11803,11791,11797,11732,11771,11207,11385,11370,11369,11372,11373,11203,11232,11218,11226,10463,10471,10030,10031,10032,10033,10034,10035,10037,10039,10040,10461,10462,10464,10465,10469,10467,10027,11201,11205,11215,11217,11231,11238,11243,11249,11211,11222,11740,11743,11746,11721,11724];

    jQuery('.submitZip').click(function(e){
        e.preventDefault();

        jQuery('.localZipError').hide();
        jQuery('.localZipConfirm').hide();

        if(!zipCodes.includes(parseInt(jQuery('#zipDelivery').val()))) {
            jQuery('.localZipError').show();

        } else {
            Cookies.set('currentMethod', 'localDelivery');
            Cookies.set('localZip', jQuery('#zipDelivery').val());
            jQuery('.shipping-selector-sidebar .sub-info .selected').html('Local delivery')
            jQuery('.shipping_options .delivery-type').text('Local delivery');
            jQuery('.shipping-selector-sidebar #shippingSelector2').click();
            jQuery('.localZipConfirm').show();

           // $('.shipping-selector-sidebar').removeClass('open'); 
        }
    })

    jQuery('.submitZipPDP').click(function(e){
        e.preventDefault();

        jQuery('.localZipError').hide();
        jQuery('.localZipConfirm').hide();

        if(!zipCodes.includes(parseInt(jQuery('#zipDeliveryPDP').val()))) {
            jQuery('.localZipError').show();

            if(jQuery('.manyVariants').length) { 
                jQuery('.variantAdd2Cart').hide();
                jQuery('.notAvaila').hide();
            } else {
                $('.shippingItem .product-form').find('.product-form__cart-submit').hide();
                jQuery('.notAvaila').hide();
            }

        } else {
            Cookies.set('currentMethod', 'localDelivery');
            Cookies.set('localZip', jQuery('#zipDeliveryPDP').val());
            jQuery('.shipping-selector-sidebar .sub-info .selected').html('Local delivery')
            jQuery('.shipping_options .delivery-type').text('Local delivery');

            jQuery('.localZipConfirm').show();

            isLocalDeliveryAvailable(jQuery('#zipDeliveryPDP').val());

        }
    })

    if(Cookies.get('localZip')) {
        jQuery('#zipDelivery').val(Cookies.get('localZip'))
    }



    jQuery.ajax({
        type: "GET",
        url: 'https://tb-location-inventory.dev.sellry.com/locations', 
        crossDomain: true,
        success: function(response){

            var isFirst = true;

            jQuery('.pickup_container ul li').remove();

            jQuery('.delivery_container ul li').remove();

            jQuery('.delivery-type').text('');
            jQuery('.delivery-location').text('');
        
            // if user just visited store - default method is Shipping
            if(!Cookies.get('currentMethod')) {
                // if product do not allow shipping set local delivery
                if(!jQuery('.noShipping').length){
                   // Cookies.set('currentMethod', 'shipping');
                   // jQuery('.delivery-type').text('SELECT YOUR SHOPPING METHOD');
 
                    if(jQuery('.template-product').length) {
                        jQuery('.manyVariants, .product-form-product-template, .product__policies').hide();
                        jQuery('.head-ship').removeClass('head-active'); 
                        jQuery('<p class="selectShopping">PLEASE SELECT YOUR SHOPPING METHOD</p>').insertBefore(jQuery('.available_block')) 
                        jQuery('.template-product').addClass('shopping-unselected');
                    }

                } else {
                    Cookies.set('currentMethod', 'localDelivery');
                }

            } 
            
            var currentMethod = Cookies.get('currentMethod')
            

            jQuery('.delivery_container ul, .pickup_container ul').removeClass('disabled')

            var iterator = 1;

            for(deliveryMethod of response) {

                if(deliveryMethod.id == 60962504766 || deliveryMethod.id == 60962537534 ||
                   deliveryMethod.id == 60962570302 || deliveryMethod.id == 60962603070 ||
                   deliveryMethod.id == 60992520254 || deliveryMethod.id == 35571793982 ||
                   deliveryMethod.id == 60954542142 || deliveryMethod.id == 36844765246) {
                       continue;
                   }
           

                   var ifHideLoc = false;   
                   if(deliveryMethod.name.includes('CLONE') || deliveryMethod.name.includes('Brewery 225') || deliveryMethod.name.includes('Gowanus')) {
                       ifHideLoc = true;  
                       
                       if($('.noShipping.kegPDP').length && deliveryMethod.name.includes('Keg Pickup')) {
                           ifHideLoc = false;
                           deliveryMethod.name = 'Keg PickUp  (225 Third Ave)';
                       }
                     
                   }   
   
                   if($('.noShipping.kegPDP').length && deliveryMethod.name.includes('Keg')) {
                       ifHideLoc = true;  
                   }
   
   
                   /* pick up */
                   if(deliveryMethod.id != 60930261054  && !deliveryMethod.name.includes('Governors Island') &&  !ifHideLoc) {
                       if(isFirst) {
                        isFirst = false;

                        if(jQuery('.template-product').length) {

                            var pickupActiveClass = '';
                            if(!Cookies.get('currentDelivery') || Cookies.get('currentDelivery') == deliveryMethod.id) {
                                pickupActiveClass = 'localActive'; 
                                jQuery('.activeLocalPickup').text(deliveryMethod.name);
                                jQuery('.activeLocalPickup').attr('pickup-id', deliveryMethod.id)
                            }

                            jQuery('<a href="#" pickup-id="' + deliveryMethod.id + '" class="localPickupItem '+ pickupActiveClass +'">' + deliveryMethod.name + '</a>').appendTo('.localPickupList');

                        }

                        jQuery('<li><input type="radio" pickup-id="' + deliveryMethod.id + '" name="pickup" id="pickupSelector' + iterator + '"><label for="pickupSelector' + iterator + '">'+ deliveryMethod.name + '</label></li>').appendTo('.pickup_container ul');



                    } else {

                        if(jQuery('.template-product').length) {
                            var pickupActiveClass = '';
                            if(Cookies.get('currentDelivery') && Cookies.get('currentDelivery') == deliveryMethod.id) {
                                pickupActiveClass = 'localActive'; 
                                jQuery('.activeLocalPickup').text(deliveryMethod.name);
                                jQuery('.activeLocalPickup').attr('pickup-id', deliveryMethod.id)
                            }

                            jQuery('<a href="#" pickup-id="' + deliveryMethod.id + '" class="localPickupItem '+ pickupActiveClass +'">' + deliveryMethod.name + '</a>').appendTo('.localPickupList');

                        }

                        jQuery('<li><input type="radio" pickup-id="' + deliveryMethod.id + '" name="pickup" id="pickupSelector' + iterator + '"><label for="pickupSelector' + iterator + '">'+ deliveryMethod.name + '</label></li>').appendTo('.pickup_container ul');


                    }
                    
                }

                iterator++;

            }


            if(currentMethod == 'shipping') {

                if(jQuery('.template-product').length) {

                    $('.headItem').removeClass('head-active');
                    $('.head-ship').addClass('head-active');
                    jQuery('.availRow, .localDeliveryDiv, .localPickupDiv').hide();
                    jQuery('.shippingItem').show();

                    var productId = jQuery('.grid.product-single').attr('data-product-id');
                    var locationId = 24131856; // Gowanus

                    if($('.noShipping.shippingItem').length) {
                        $('.headItem.head-local').click();
                    } else {
                        if(jQuery('.manyVariants').length) { 
                            IsVariantsAvailable(productId, locationId); 
                        } else {
                            IsVariantAvailable(productId, locationId); 
                        }
                    }

                }

                if(jQuery('.template-cart').length) {

                    var checkExist = setInterval(function() {
                        if ($('.checkoutMethodContainer.delivery .inputWithButton #deliveryGeoSearchField').length) {

                            jQuery('#storePickupApp .checkoutMethodsContainer, .checkoutMethodContainer.delivery .inputWithButton, .checkoutMethodContainer.delivery .delivery_note').hide();
                            jQuery('#storePickupApp .checkoutMethod').eq(1).click();

                            jQuery('.cartCheckout h3').text('');

                            clearInterval(checkExist);
                        }
                   }, 100);

                } 


                jQuery('.delivery-type').text('Shipping');

                jQuery('.shipping-selector-sidebar #shippingSelector1').click();

                jQuery('.shipping-selector-sidebar .sub-info .selected').html('Shipping <span class="delivery_option"></span>')

            }

            /* if(currentMethod == 'localDelivery') {

                if(jQuery('.template-product').length) {

                    $('.headItem').removeClass('head-active');
                    $('.head-local').addClass('head-active');
                    jQuery('.availRow, .localPickupDiv').hide();
                    jQuery('.shippingItem, .localDeliveryDiv').show();

                    var productId = jQuery('.grid.product-single').attr('data-product-id');

                    if(Cookies.get('localZip')) {
                        jQuery('#zipDeliveryPDP').val(Cookies.get('localZip'))
                        isLocalDeliveryAvailable(Cookies.get('localZip'))

                        jQuery('.variantAdd2Cart').hide();
                        jQuery('.notAvaila').hide();
            
                        if(jQuery('#zipDeliveryPDP').val().length > 3) {
                            jQuery('.submitZipPDP').click();
                        }
                                

                    } else {
                        jQuery('.variantAdd2Cart').hide();
                        jQuery('.notAvaila').hide();
                    }

                }

                if(jQuery('.template-cart').length) {

                    var checkExist = setInterval(function() {
                        if ($('.checkoutMethodContainer.delivery .inputWithButton #deliveryGeoSearchField').length) {

                            if(Cookies.get('localZip')) {
                                jQuery('#storePickupApp .checkoutMethodsContainer, .checkoutMethodContainer.delivery .inputWithButton, .checkoutMethodContainer.delivery .delivery_note').hide();
                                jQuery('#storePickupApp .checkoutMethod').eq(0).click();

                                jQuery('.cartCheckout h3').text('Local delivery:');
        
                                jQuery('.checkoutMethodContainer.delivery .inputWithButton #deliveryGeoSearchField').val(Cookies.get('localZip'));
                                jQuery('.checkoutMethodContainer.delivery .inputWithButton .searchIcon').click();
                            }

                            clearInterval(checkExist);
                        }
                   }, 100);

                }

                jQuery('.delivery-type').text('Local Delivery');

                jQuery('.shipping-selector-sidebar .sub-info .selected').html('Local delivery')


            }*/


            /* if(currentMethod == 'PickUp') {

                var locationId = Cookies.get('currentDelivery');

                if(jQuery('.template-product').length) {
                    $('.headItem').removeClass('head-active');
                    $('.head-pick').addClass('head-active');
                    jQuery('.availRow, .localDeliveryDiv').hide();
                    jQuery('.shippingItem, .localPickupDiv').show();

                    var productId = jQuery('.grid.product-single').attr('data-product-id');

                    if(jQuery('.manyVariants').length) {
                        IsVariantsAvailable(productId, locationId);
                    } else {
                        IsVariantAvailable(productId, locationId);
                    }
                }

                jQuery('.delivery-type').text('PickUp');
                jQuery('.delivery-location').text(' - ' + jQuery('.pickup_container input[name="pickup"][pickup-id="' + locationId +  '"').parent().find('label').text());

                jQuery('.shipping-selector-sidebar .sub-info .selected').html('PickUp <span class="delivery_option">'+ ' - ' + jQuery('.pickup_container input[name="pickup"][pickup-id="' + locationId +  '"').parent().find('label').text() +' </span>')


                jQuery('.shipping-selector-sidebar #shippingSelector3').click();
                jQuery('.pickup_container input[name="pickup"][pickup-id="' + locationId +  '"').click();

                if(jQuery('.template-cart').length) {


                    var locationName = jQuery('.pickup_container input[name="pickup"][pickup-id="' + locationId +  '"').parent().find('label').text().replace('Threes ', '');

                    var checkExist = setInterval(function() {
                        if ($('.checkoutMethodContainer.delivery .inputWithButton #deliveryGeoSearchField').length || $('#storePickupApp .error[role="alert"]').length) {

                            jQuery('.cartCheckout h3').text('Store Pickup:');

                            jQuery('#storePickupApp .checkoutMethodsContainer, .checkoutMethodContainer.delivery .inputWithButton').hide();
                            jQuery('#storePickupApp .checkoutMethod').eq(2).click();

                            clearInterval(checkExist);
                        }
                   }, 500);


                   if(locationName.length && locationName.length > 3) {

                    var checkExistPickups = setInterval(function() {
                        if($('.checkoutMethodContainer.pickup').find('.locations .location.active').length) {
                            $('.checkoutMethodContainer.pickup').find('.locations .location').each(function(){

                                if($(this).find('.block .name').text().includes(locationName)) {
                                    $(this).click();
                                } 
                            })
    
                            clearInterval(checkExistPickups);
                        }
                      }, 500);
                   }


                }


            } */

        }
    });

    jQuery('.shipping-selector-sidebar .confirm_btn').click(function(){
        jQuery('.shipping-selector-sidebar').removeClass('open')
        jQuery('body').removeClass('open')

        if(jQuery('input[type="radio"][name="shipping"]:checked').val() == 'shipping') {
            Cookies.set('currentMethod', 'shipping');

            jQuery('.shipping_options .delivery-type').text('Shipping')
            jQuery('.shipping_options .delivery-location').text('')

            if(jQuery('.template-product').length) {
                jQuery('.head-ship').click();
             }

             if(jQuery('.template-cart').length) {
                window.location.reload();
             } else {
                isItemsInCartMatchLocation();
             }


        }
        

        if(jQuery('input[type="radio"][name="shipping"]:checked').val() == 'pickup') {
            Cookies.set('currentMethod', 'PickUp');
            var currentLocId = jQuery('input[type="radio"][name="pickup"]:checked').attr('pickup-id');
            Cookies.set('currentDelivery',currentLocId);

            jQuery('.shipping_options .delivery-type').text('Pickup')
            jQuery('.shipping_options .delivery-location').text(' - '+ jQuery('input[type="radio"][name="pickup"]:checked').parent().find('label').text())


            if(jQuery('.template-product').length) {
                jQuery('.activeLocalPickup').attr('pickup-id', currentLocId);
                jQuery('.localPickupItem[pickup-id="' + currentLocId + '"]').click();
                jQuery('.head-pick').click();
             }
        }

        window.location.reload();

    })

    jQuery('body').on('change', 'input[name=\'pickup\']',  function(){

        jQuery('.shipping-selector-sidebar #shippingSelector3').click();

        $('input[name=\'local_delivery\']').each(function(){
            $(this).prop('checked', false);
        });


        jQuery('.shipping-selector-sidebar .sub-info .selected').html('PickUp <span class="delivery_option">'+ '  - '+ jQuery('input[type="radio"][name="pickup"]:checked').parent().find('label').text()+' </span>')


    })

    jQuery('input[name=\'shipping\']').on('change', function(){


        if(jQuery(this).val() == 'shipping') {

            $('input[name=\'local_delivery\']').each(function(){
                $(this).prop('checked', false);
            });

            $('input[name=\'pickup\']').each(function(){
                $(this).prop('checked', false);
            });

            jQuery('.shipping-selector-sidebar .sub-info .selected').html('Shipping <span class="delivery_option"> </span>')


        }

        if(jQuery(this).val() == 'pickup') {

            $('input[name=\'local_delivery\']').each(function(){
                $(this).prop('checked', false);
            });

            if(!jQuery("input:radio[name='pickup']").is(":checked")) {
                jQuery("input:radio[name='pickup']").first().click()
            }

        }

        if(jQuery(this).val() == 'delivery') {

            $('input[name=\'pickup\']').each(function(){
                $(this).prop('checked', false);
            });

        }

  

    });

    
    if(jQuery('.template-product').length) {

        jQuery('body').on('click', '.head-local, .head-pick, .head-ship', function() {
            if(jQuery('.manyVariants').length) {
                jQuery('.manyVariants').show();
            } else {
                jQuery('.product-form-product-template').show();
            }
            jQuery('.selectShopping').hide();
            jQuery('.product__policies').show();
            jQuery('.template-product').removeClass('shopping-unselected'); 
        });


        jQuery('body').on('click', '.head-local',function(){
            if(jQuery('.manyVariants').length) { 
                jQuery('.variantAdd2Cart').hide();
                jQuery('.notAvaila').hide();
            } else {
                $('.shippingItem .product-form').find('.product-form__cart-submit').hide();
                jQuery('.notAvaila').hide();
            }


            jQuery('.delivery-type').text('Local delivery');
            jQuery('.delivery-location').text('');

            if($('.hiddenPId').length && $('.hiddenPId').val() == 4471229317182) {
                $('.variantAdd2Cart').show();
                $('.notAvaila').hide(); 
            }

            if(jQuery('#zipDeliveryPDP').val().length > 3) {
                jQuery('.submitZipPDP').click();
            }
            
        })

        jQuery('body').on('click', '.head-pick',function(){

            var productId = jQuery('.grid.product-single').attr('data-product-id');
            var locationId = jQuery('.activeLocalPickup').attr('pickup-id');

            jQuery('.delivery-type').text('Pick Up');

            if(locationId) {
                Cookies.set('currentDelivery', locationId);
                Cookies.set('currentMethod', 'PickUp');
                if(jQuery('.manyVariants').length) {
                    IsVariantsAvailable(productId, locationId);
                } else {
                    IsVariantAvailable(productId, locationId);
                }

            } else {
                jQuery('.localPickupList a').first().click();
            }   



        })

        jQuery('body').on('click', '.localPickupList a', function(e){

            e.preventDefault();

            jQuery('.localPickupItem').removeClass('localActive');
            jQuery(this).addClass('localActive');
            jQuery('.activeLocalPickup').text(jQuery(this).text());

            jQuery('.delivery-type').text('Pick Up');
            jQuery('.delivery-location').text(' - ' + jQuery(this).text());



            var productId = jQuery('.grid.product-single').attr('data-product-id');
            var locationId = jQuery(this).attr('pickup-id');
            Cookies.set('currentMethod', 'PickUp');
            Cookies.set('currentDelivery', locationId);
            

             jQuery('.activeLocalPickup').attr('pickup-id', locationId);

             if(jQuery('.manyVariants').length) {
                IsVariantsAvailable(productId, locationId);
             } else {
                IsVariantAvailable(productId, locationId);
             }

        });


        jQuery('body').on('click', '.head-ship',function(){
            var productId = jQuery('.grid.product-single').attr('data-product-id');
            var locationId = 24131856; // Gowanus

            jQuery('.delivery-type').text('Shipping');
            jQuery('.delivery-location').text('');
            Cookies.set('currentMethod', 'shipping');

            if(jQuery('.manyVariants').length) {
                IsVariantsAvailable(productId, locationId);
             } else {
                IsVariantAvailable(productId, locationId);
             }
        })

    }

    if(jQuery('.form--container.tripleseat').length) {
        var checkExistT = setInterval(function() {
            if (jQuery('.tripleseat-success-message p').is(':visible')) {
                jQuery('#lead_form_submit').hide();
                clearInterval(checkExistT);
            }
        }, 1000);

    }


    if($('.feature-row__item.gowanus_hours').length){
        //$('.table-cell.feature-row__item .subrow').eq(1).find('.grid__item').eq(0).find('.featured-row__subtext p').text('Currently Closed');
        const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
        const d = new Date();
        let day = weekday[d.getDay()];

        $('.feature-row__item.gowanus_hours .opening-day').each(function(){
            if($(this).text() == day) {
                $('.table-cell.feature-row__item .subrow').eq(1).find('.grid__item').eq(0).find('.featured-row__subtext p').text($(this).next().text());
            }
        })
    }



});


function IsVariantsAvailable(productId, locationId) {
    
    if(productId == 4471229317182) {
        jQuery('.varintRow').find('.variantAdd2Cart').show();
        jQuery('.varintRow').find('.notAvaila').hide(); 
        return;
    }

    //Keg with untracked inventory
    if(productId == 6926686814270 && locationId == 60962308158) {
        jQuery('.varintRow').find('.variantAdd2Cart').show();
        jQuery('.varintRow').find('.notAvaila').hide(); 
        return; 
    }
    

    jQuery('.varintRow').each(function(){
        var variantId = jQuery(this).find('.hiddenId').val();

        var URL = 'https://tb-location-inventory.dev.sellry.com/single_product?';
        URL+= 'product_id=' + productId;
        URL+= '&variant_id=' + variantId;
        URL+= '&location_id=' + locationId;

        var targetEl = $(this);
        jQuery.ajax({
            type: "GET",
            url: URL,
            crossDomain: true,
            success: function(response){

                if(productId == 4776137818174 ||
                    productId == 4776137818174  ) {
                        response = true; 
                    }


            if(!$('.headItem.head-local').hasClass('head-active')) {

                if(response == false) {

                    if(!$(targetEl).find('.varianttitle').text().includes('Single') ) {
                        targetEl.find('.variantAdd2Cart').hide();
                        targetEl.find('.notAvaila').show();
                    }


                    if($(targetEl).find('.varianttitle').text().includes('4-Pack') 
                        &&  $(targetEl).parent().find('.varintRow').first().find('.varianttitle').text().includes('Single')) {
                        $(targetEl).parent().find('.varintRow').first().find('.variantAdd2Cart').hide();
                        $(targetEl).parent().find('.varintRow').first().find('.notAvaila').show();
                    }

                } else {
                    targetEl.find('.variantAdd2Cart').show();
                    targetEl.find('.notAvaila').hide(); 

                    if($(targetEl).find('.varianttitle').text().includes('4-Pack') 
                      &&  $(targetEl).parent().find('.varintRow').first().find('.varianttitle').text().includes('Single')) {
                        $(targetEl).parent().find('.varintRow').first().find('.variantAdd2Cart').show();
                        $(targetEl).parent().find('.varintRow').first().find('.notAvaila').hide();
                    }
                }
            
            
            }

            }

        });
    })

}


function IsVariantAvailable(productId, locationId, variantId = null) {

    if(!variantId) {
        var variantId = jQuery('.hiddenId').val();
    }

    if($('.product-form.product-form__controls').length && $('.product-form.product-form__controls')[0].hasAttribute("data-variant-info") && 
        $('.product-form.product-form__controls').attr('data-variant-info') == "true") {
            return; 
    }

    if(productId == 4471229317182) {
        $('.shippingItem .product-form').find('.product-form__cart-submit').show();
        $('.shippingItem .product-form').find('.notAvaila').hide(); 
        return;
    }


    var URL = 'https://tb-location-inventory.dev.sellry.com/single_product?';
    URL+= 'product_id=' + productId;
    URL+= '&variant_id=' + variantId;
    URL+= '&location_id=' + locationId;

    var targetEl = $('.shippingItem .product-form');
    jQuery.ajax({
        type: "GET",
        url: URL,
        crossDomain: true,
        success: function(response){


            if(productId == 4776137818174 ||
                productId == 6765700218942 ||
                productId == 4474383007806 ||
                productId == 4474382712894 || 
                productId == 4477714268222 ||
                productId == 6765508329534 ||
                productId == 6765488734270 ||
                productId == 6747401683006 ||
                productId == 6747237023806 ) {
                    response = true; 
                    $('.klaviyo-bis-trigger').hide();
                }

            if(!$('.headItem.head-local').hasClass('head-active')) {
                if(response == false) {
                    targetEl.find('.product-form__cart-submit').hide();
                    targetEl.find('.notAvaila').show();
                } else {
                    targetEl.find('.product-form__cart-submit').show();
                    targetEl.find('.notAvaila').hide(); 
                }
            }   


        }

    });

}


function isLocalDeliveryAvailable(zip) {



    jQuery('.product-single__meta .productData').each(function(){

        if($(this).find('.hiddenPId').val() == 4471229317182) {
            $('.variantAdd2Cart').show();
            $('.notAvaila').hide(); 
            return;
        }

        var currentProduct = $(this).parent().parent();

        if(jQuery('.manyVariants').length && currentProduct.find('.varianttitle label').text().includes('Single')) {
            return true;
        }

        var zapietData = {
            "geoSearchQuery": zip,
            "shoppingCart": [
                {
                    "variant_id": $(this).find('.hiddenId').val(),
                    "product_id": $(this).find('.hiddenPId').val(),
                    "quantity": 1
                }
            ]
        };

        console.log(zapietData)
    
        jQuery.ajax({
            type: "POST",
            url: 'https://api-us.zapiet.com/v1.0/delivery/locations?api_key=c8000af31845475b2b829aa4d7a3fa51&shop=threesbrewing.myshopify.com', 
            data: zapietData, 
            crossDomain: true,
            success: function(response){

                if(response.hasOwnProperty('id')) {

                    if(jQuery('.manyVariants').length) { 
                        currentProduct.find('.variantAdd2Cart').show();
                        currentProduct.find('.notAvaila').hide();

                        if(currentProduct.find('.varianttitle label').text().includes('4-Pack') &&
                        $('.manyVariants .varintRow').eq(0).find('.varianttitle label').text().includes('Single') ) {
                           
                            $('.manyVariants .varintRow').eq(0).find('.variantAdd2Cart').show();
                            $('.manyVariants .varintRow').eq(0).find('.notAvaila').hide();
                        }

                    } else {
                        $('.shippingItem .product-form').find('.product-form__cart-submit').show();
                        jQuery('.notAvaila').hide();
                    }


                } else {
                    if(jQuery('.manyVariants').length) { 
                        currentProduct.find('.variantAdd2Cart').hide();
                        currentProduct.find('.notAvaila').show();

                        //hide single if 4-pack not available
                        if(currentProduct.find('.varianttitle label').text().includes('4-Pack') &&
                        $('.manyVariants .varintRow').eq(0).find('.varianttitle label').text().includes('Single') ) {
                           
                            $('.manyVariants .varintRow').eq(0).find('.variantAdd2Cart').hide();
                            $('.manyVariants .varintRow').eq(0).find('.notAvaila').show();
                        }

                    } else {
                        $('.shippingItem .product-form').find('.product-form__cart-submit').hide();
                        jQuery('.notAvaila').show();
                    }

                }
 
            }
    
        });

    })

}

function isItemsInCartMatchLocation() {

    //since we have only 1 location there is no sense to check locations 
    return;

    jQuery.getJSON('/cart.js', function(cart) {

        if(Cookies.get('currentDelivery') && (Cookies.get('currentMethod') == 'shipping' || Cookies.get('currentMethod') == 'PickUp')) {

            var items = [];

            var iterator = 0;

            var isItemsRemoved = false;



            if(Cookies.get('currentMethod') == 'shipping') {
                var locationId = 60899622974;
            } else {
                var locationId = Cookies.get('currentDelivery');
            } 

            for(cartItem of cart.items) {
                var cartCount =  cart.item_count;
                if(cartItem.title.includes('Gift Card')) {
                    continue
                }

                if(cartItem.title.includes('24-')) {
                    continue
                }

                //keg with untracked inventory
                if(cartItem.product_id == 6926686814270 && locationId != 36844765246) {
                    continue
                }

                var URL = 'https://tb-location-inventory.dev.sellry.com/single_product?';


                if(Cookies.get('currentMethod') == 'shipping') {
                    // check if we have items that can't be shipped if delivery method is Shipping
                    // temp fix with ID's
                    if(cartItem.product_id == 4776137818174 ||
                        cartItem.product_id == 6765700218942 ||
                        cartItem.product_id == 4474383007806 ||
                        cartItem.product_id == 4474382712894 || 
                        cartItem.product_id == 4477714268222 ||
                        cartItem.product_id == 6765508329534 ||
                        cartItem.product_id == 6765488734270 ||
                        cartItem.product_id == 6747401683006 ||
                        cartItem.product_id == 6747237023806 ||
                        cartItem.product_id == 6601085911102) {
                            var currentEl = cartItem;
                            jQuery.ajax({
                                type: 'POST',
                                url: '/cart/change.js',
                                data: 'quantity=' + 0 + '&id=' + cartItem.variant_id,
                                dataType: 'json',
                                success: function(line_item) {
                                    $('#beerModal .modalText ').text(currentEl.title + ' was removed from the cart because it is not available for the current shopping method');
                                    
                                    if(cartCount <= 1) {
                                        $('#beerModal .goCheckout').hide();
                                        $('#beerModal .keepShopping').addClass('toPLP');
                                    }

                                    $('#beerModal').show();
                                }
                            }) 
        
                        } 

                } 



                if(cartItem.title && !cartItem.title.includes('Single Can') ) {

                    URL+= 'product_id=' + cartItem.product_id;
                    URL+= '&variant_id=' + cartItem.variant_id;
                    URL+= '&location_id=' + locationId;

                    var currentEl = cartItem;
                    

                    console.log(URL)
                    jQuery.ajax({
                        type: "GET",
                        async: false,
                        url: URL,
                        crossDomain: true,
                        success: function(response){
                
                            if(response == false) {

                                console.log(cartItem.title)
                                console.log(cartItem.variant_id)
                                
                                jQuery.ajax({
                                    type: 'POST',
                                    url: '/cart/change.js',
                                    data: 'quantity=' + 0 + '&id=' + currentEl.variant_id,
                                    dataType: 'json',
                                    async: false,
                                    success: function(line_item) {

                                        $('#beerModal .modalText ').text(currentEl.title + ' was removed from the cart because it is not available for the current shopping method');

                                        if(cartCount <= 1) {
                                            $('#beerModal .goCheckout').hide();
                                            $('#beerModal .keepShopping').addClass('toPLP');
                                        }

                                        $('#beerModal').show();
                                        //window.location.reload();
                                    }
                                })
                            }
                
                
                        }
                
                    });

                }



            }  


        }    

    });


    var modal = document.getElementById("beerModal");

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
        if (event.target == modal) {
            modal.style.display = "none";
        }
    }


    $('body').on('click', '#beerModal .close', function(){
        $('#beerModal').hide();
    })

    $('body').on('click', '#beerModal .keepShopping', function(){
        if($(this).hasClass('toPLP')) {
            window.location.href = 'https://shop.threesbrewing.com/collections/beer';
        } else {
            window.location.reload();
        }

    })


    $('body').on('click', '#beerModal .goCheckout', function(){
        window.location.href = '/checkout';
    })

    

}